import { useState, useEffect, useRef } from "react";
import { useNavigate, generatePath, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "./Header";
import Sidebar from "./Sidebar";
import http from "../api/server";
import { Box, IconButton } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import useGetClientId from "../hooks/useGetClientId";
import {
  ADD_BLOCK_BY_CLIENT_ID,
  ADD_PROPERTY_BY_CLIENT_ID,
  DELETE_PROPERTY_BY_MASTER_ID,
  GET_ALL_PROPERTY_BY_CLIENT_ID,
  GET_BLOCK_BY_CLIENT_ID,
  GET_USERS_ROLE_BY_CLIENT_ID,
  POST_PROPERTY_FLOOR_IAMGE,
} from "../api/apiPath";
import Toaster from "./common/Toaster";
import { hostName } from "../config/config";
import { useSelector } from "react-redux";
import UpdateProperty from "./UpdateProperty";
import FileUpload from "./common/FileUpload";
import useGetCity from "../hooks/useGetCity";
import DynamicTable from "./common/DynamicTable";
import DynamicTiles from "./common/DynamicTiles";
import ConfirmationPopup from "./common/ConfirmationPopup";
import LoadingComponent from "./common/LoadingComponent";
import SidebarIcons from "./SidebarIcons";
// import del from "../assets/img/del.png";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import delicon from "../assets/img/del.png";
import ClearIcon from "@mui/icons-material/Clear";

const AddBlockModalPopup = ({
  setShowAddBlockModal,
  addNewBlockValue,
  setAddNewBlockValue,
  handleAddBlock,
  hanleSaveBlock,
}) => {
  return (
    <div className="dashboard_body_main d-flex vh-100">
      <div className="d-flex dashboard_body flex-column py-3 ">
        <div className="modal-overlay">
          <div
            className="approval-modal-content"
            style={{ height: "fit-content" }}
          >
            <span
              className="close"
              onClick={() => {
                setShowAddBlockModal(false);
                setAddNewBlockValue("");
              }}
            >
              &times;
            </span>
            <h6 className="modal-header">Add Block</h6>

            <div className="modal-body">
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="address1"
                  placeholder=" "
                  value={addNewBlockValue}
                  onChange={handleAddBlock}
                  required
                />
                <label htmlFor="address1">Add Block</label>
              </div>

              <div className="d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap mt-3">
                <button
                  type="button"
                  className="btn btn-tertiary"
                  onClick={() => {
                    setShowAddBlockModal(false);
                    setAddNewBlockValue("");
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={hanleSaveBlock}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddProperty = () => {
  const [toolbar, setToolBar] = useState({
    searchText: "",
    property_name: "Propertyname",
    property_address: "Propertyaddress",
    inspector: "Inspector",
    approver: "Approver",
    propertyType: "Property Type",
  });
  const isAnyFilterApplied =
    toolbar.searchText !== "" ||
    toolbar.property_name !== "Propertyname" ||
    toolbar.inspector !== "Inspector" ||
    toolbar.approver !== "Approver" ||
    toolbar.propertyType !== "Property Type";

  const fileInputRef = useRef(null);
  const { userObj } = useSelector((state) => state.user);
  const [hideSidebar, setHideSidebar] = useState(true);
  const [blocksList, setBlocksList] = useState(null);
  const [approverList, setApproverList] = useState(null);
  const [inspectorList, setInspectorList] = useState(null);
  const [allPropertyList, setAllPropertyList] = useState(null);
  const [editProperty, setEditProperty] = useState(null);
  const [showAddBlockModal, setShowAddBlockModal] = useState(false);
  const [propertyName, setPropertName] = useState("");
  const [propertyAddress, setPropertAddress] = useState("");
  const [totalFloor, setTotalFloor] = useState("");
  const [propertyPostalCode, setPropertPostalCode] = useState("");
  const [propertImage, setPropertyImage] = useState("");
  const [previewPropertImage, setPreviewPropertImage] = useState("");
  const [propertyBlockObj, setPropertyBlockName] = useState("");
  const [addNewBlockValue, setAddNewBlockValue] = useState("");
  const [propertyCity, setPropertyCity] = useState("");
  const [propertyStatus, setPropertyStatus] = useState("Active");
  const [propertyInspector, setPropertyInspector] = useState([]);
  const [propertyApprover, setPropertyApprover] = useState([]);
  const [renderAddProperty, setRenderAddProperty] = useState(false);
  const [renderUpdateProperty, setRenderUpdateProperty] = useState(false);
  const [validationFlag, setValidationFlag] = useState(false);
  const [files, setFiles] = useState([]);
  const [city, setCity] = useState(null);
  const [loading, setLoading] = useState(true);
  const cityObj = useGetCity();
  const [errorPostCode, setErrorPostCode] = useState("");
  const [showFloorImages, setShowFloorImages] = useState(false);
  const navigate = useNavigate();
  const { clientNameParam } = useParams();


  const blockRef = useRef(null);
  const nameRef = useRef(null);
  const addressRef = useRef(null);
  const cityRef = useRef(null);
  const postalCodeRef = useRef(null);
  const totalFloorRef = useRef(null);
  const inspectorRef = useRef(null);
  const approverRef = useRef(null);

  const filteredRows = allPropertyList?.filter((row) => {
    const matchesSearch =
      !toolbar.searchText ||
      row.propertyName
        ?.toLowerCase()
        .includes(toolbar.searchText.toLowerCase()) ||
      row.propertyLocation
        ?.toLowerCase()
        .includes(toolbar.searchText.toLowerCase()) ||
      row.propertyStatus
        ?.toLowerCase()
        .includes(toolbar.searchText.toLowerCase()) ||
      (Array.isArray(row.inspectors) &&
        row.inspectors.some((inspector) =>
          inspector.fullName
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase())
        )) ||
      (Array.isArray(row.approvers) &&
        row.approvers.some((approver) =>
          approver.fullName
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase())
        ));

    const matchesName =
      toolbar.property_name === "Propertyname" ||
      row.propertyName === toolbar.property_name;

    const matchesInspector =
      toolbar.inspector === "Inspector" ||
      (Array.isArray(row.inspectors) &&
        row.inspectors.some(
          (inspector) => inspector.fullName === toolbar.inspector
        ));

    const matchesApprover =
      toolbar.approver === "Approver" ||
      (Array.isArray(row.approvers) &&
        row.approvers.some(
          (approver) => approver.fullName === toolbar.approver
        ));

    const matchesUserType =
      toolbar.propertyType === "Property Type" ||
      row.propertyStatus === toolbar.propertyType;

    return (
      matchesSearch &&
      matchesName &&
      matchesInspector &&
      matchesApprover &&
      matchesUserType
    );
  });
  const allInspectors = Array.isArray(allPropertyList)
    ? allPropertyList.flatMap((property) =>
        Array.isArray(property.inspectors) ? property.inspectors : []
      )
    : [];

  const uniqueInspectors = [
    ...new Map(
      allInspectors.map((inspector) => [inspector.userId, inspector])
    ).values(),
  ];

  const allApprovers = Array.isArray(allPropertyList)
    ? allPropertyList.flatMap((property) =>
        Array.isArray(property.approvers) ? property.approvers : []
      )
    : [];

  const uniqueApprovers = [
    ...new Map(
      allApprovers.map((approver) => [approver.userId, approver])
    ).values(),
  ];

  const handleCityChange = (e) => {
    cityRef.current.style.border = "";
    const selectedCountry = e.target.value;
    setPropertyCity(selectedCountry);
    console.log("Selected country:", selectedCountry);
  };
  useEffect(() => {
    setCity(cityObj?.cityList);
  }, [cityObj.cityList, cityObj.loading]);
  const [floorEntries, setFloorEntries] = useState([
    { floor: "", image: null },
  ]);

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  // const navigate = useNavigate();
  const clientObj = useGetClientId();

  // Options for the floor number dropdown
  const floorOptions = Array.from({ length: totalFloor }, (_, i) => i + 1); // Floors 1-10

  // Function to add a new floor entry
  const handleAddFloor = () => {
    setFloorEntries([...floorEntries, { floor: "", image: null }]);
  };

  // Function to remove a floor entry by index
  const handleRemoveFloor = (index) => {
    const newFloorEntries = floorEntries.filter((_, i) => i !== index);
    setFloorEntries(newFloorEntries);
  };

  // Function to handle floor number change for a specific entry
  const handleFloorChange = (index, value) => {
    const newFloorEntries = [...floorEntries];
    newFloorEntries[index].floor = value;
    newFloorEntries[index].requireFloor = "";
    setFloorEntries(newFloorEntries);
  };

  // Function to handle image file selection for a specific entry
  const handleImageChange = (index, file) => {
    const newFloorEntries = [...floorEntries];
    newFloorEntries[index].image = file;
    newFloorEntries[index].requireImage = "";
    setFloorEntries(newFloorEntries);
  };

  const checkFloorEntries = (entries) => {
    const isObjectValuesEmpty = (obj) => {
      return Object.values(obj).every(
        (value) =>
          value === null ||
          value === undefined ||
          value === "" ||
          value === "Select" ||
          value === "Please select floor" ||
          value === "Please upload floor plan image"
      );
    };

    return entries.every(isObjectValuesEmpty);
  };

  const validateFloorEntries = (cleanedFloor) => {
    const isEmptyFloorEntries = checkFloorEntries(floorEntries);
    const newFloorEntries = [...cleanedFloor];
    if (floorEntries.length > 0 && !isEmptyFloorEntries) {
      newFloorEntries.forEach((entry) => {
        if (entry.floor !== "Select" && entry.floor !== "" && !entry.image)
          entry.requireImage = "Please upload floor plan image";
        if (entry.image && (!entry.floor || entry.floor === "Select"))
          entry.requireFloor = "Please select floor";
      });
    }
    return newFloorEntries;
  };

  const getBlockByClientID = async (clientId) => {
    try {
      const response = await http.get(
        GET_BLOCK_BY_CLIENT_ID + "?clientId=" + clientId
      );
      if (response.status === 200) {
        setBlocksList(response?.data?.blocks);
      }
    } catch (error) {
      return error;
    }
  };

  const getUsersRoleByClientId = async (clientId) => {
    try {
      const response = await http.get(
        GET_USERS_ROLE_BY_CLIENT_ID + "?clientId=" + clientId
      );
      if (response.status === 200) {
        // Filter roles
        const approvers = response?.data?.filter(
          (item) => item.roleName === "Approver"
        );
        const inspectors = response?.data?.filter(
          (item) => item.roleName === "Inspector"
        );

        // Dropdown options
        const approverOptions = approvers.map((a) => ({
          value: a.userId,
          label: a.fullName,
        }));

        const inspectorOptions = inspectors.map((i) => ({
          value: i.userId,
          label: i.fullName,
        }));
        setInspectorList(inspectorOptions);
        setApproverList(approverOptions);
      }
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    if (clientObj.clientId) {
      getBlockByClientID(clientObj.clientId);
      handleGetAllPropertyByClinetID(clientObj.clientId);
      getUsersRoleByClientId(clientObj.clientId);
    }
  }, [clientObj.clientId, clientObj.loading]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setPropertyImage(file);
    setPreviewPropertImage(URL.createObjectURL(file));
  };

  const handleSelect = (e) => {
    const foundObject = blocksList.find(
      (option) => option.blockName === e.target.value
    );
    setPropertyBlockName(foundObject);
  };

  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_ALL_PROPERTY_BY_CLIENT_ID + "?clientId=" + clientId
      );
      if (response.status === 200) {
        console.log("response.data", response.data);
        response?.data?.forEach((item) => {
          item.id = item.propertyMasterId; // Assigning a sequential ID
        });
        setAllPropertyList(response.data);
      }
    } catch (error) {
      return error;
    } finally {
      setLoading(false);
    }
  };

  const hanleSaveBlock = async () => {
    try {
      const response = await http.post(ADD_BLOCK_BY_CLIENT_ID, {
        clientId: clientObj.clientId,
        blockName: addNewBlockValue,
      });
      if (response.status !== 400) {
        setShowAddBlockModal(false);
        setAddNewBlockValue("");
        getBlockByClientID(clientObj.clientId);
      } else {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: response?.data?.message,
        });
      }
    } catch (error) {
      return error;
    }
  };

  const handleAddBlock = (e) => {
    setAddNewBlockValue(e.target.value);
  };

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };
  const floorInputRef = useRef({});
  const handleResetAddPropertyForm = () => {
    setAddNewBlockValue("");
    setPropertAddress("");
    setTotalFloor("");
    setPropertName("");
    setPropertPostalCode("");
    setPropertyBlockName("");
    setPropertyCity("");
    setPropertyImage("");
    setPreviewPropertImage("");
    resetFileInput();
    setPropertyInspector(null);
    setPropertyApprover(null);
    setErrorPostCode("");
    setValidationFlag(false);
    nameRef.current.style.border = "";
    addressRef.current.style.border = "";
    postalCodeRef.current.style.border = "";
    cityRef.current.style.border = "";
    inspectorRef.current?.controlRef?.style?.setProperty(
      "border",
      "1px solid #ccc"
    );
    approverRef.current?.controlRef?.style?.setProperty(
      "border",
      "1px solid #ccc"
    );
    setFiles([]);
    setFloorEntries([{ floor: "", image: null }]);
    Object.values(floorInputRef.current).forEach((input) => {
      if (input) input.value = "";
    });
  };
  const [error, setError] = useState("");
  const [showValidation, setShowValidation] = useState(false);
  // const fileToBase64 = (file) =>
  //   new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     reader.onload = () => resolve(reader.result.split(",")[1]); // remove "data:..;base64,"
  //     reader.onerror = reject;
  //     // reader.readAsDataURL(file);
  //   });

  const checkFloorPlanDataIsAvailable = () => {
    if (floorEntries.length === 1 || floorEntries.length > 1) {
      if (floorEntries[0].floor && floorEntries[0].image) {
        return true;
      }
    }
    return false;
  };

  const buildPayload = async (entries) => {
    const payload = await Promise.all(
      entries.map(async (fe) => ({
        complianceType: fe.type, // from dropdown
        complianceFileName: fe.docName, // editable name
        complianceFile: fe.file, // base64 string
      }))
    );
    console.log("buildPayload", payload);
    return payload;
  };
  const getPropertyId = (str) => {
    if (!str) return null; // safety check

    // Check if "=" exists
    if (str.includes("=")) {
      return str.split("=")[1]; // take value after "="
    }
    return str; // return original if "=" not present
  };
  const ukPostcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i;
  const handleSaveProperty = async (event) => {
    event.preventDefault();
    // setSaving(true);
    setValidationFlag(false);
    setShowValidation(false);
    setLoading(true);
    let isValid = true;
    // if (!files.length) {
    //   setError("Please upload at least one file.");
    //   setShowValidation(true);
    //   return;
    // }

    for (const fe of files) {
      if (!fe.docName.trim()) {
        setError("Each file must have a document name.");
        setShowValidation(true);
        isValid = false;
        setValidationFlag(true);
        setLoading(false);
        return;
      }
      if (!fe.type) {
        setError("Each file must have a type selected.");
        setShowValidation(true);
        isValid = false;
        setValidationFlag(true);
        setLoading(false);
        return;
      }
    }

    // Validate required fields
    // if (!propertyBlockObj) {
    //   isValid = false;
    //   blockRef.current.style.border = "1px solid red";
    // }
    if (!propertyName.trim()) {
      isValid = false;
      nameRef.current.style.border = "1px solid red";
    }
    if (!propertyAddress.trim()) {
      isValid = false;
      addressRef.current.style.border = "1px solid red";
    }
    if (!propertyCity) {
      isValid = false;
      cityRef.current.style.border = "1px solid red";
    }
    if (!propertyPostalCode.trim()) {
      isValid = false;
      postalCodeRef.current.style.border = "1px solid red";
    }
    if (
      propertyPostalCode &&
      !ukPostcodeRegex.test(propertyPostalCode.trim())
    ) {
      isValid = false;
      postalCodeRef.current.style.border = "1px solid red";
      setErrorPostCode("Invalid UK Postal Code");
    } else {
      setErrorPostCode("");
    }

    // if (!totalFloor || totalFloor === "0") {
    //   totalFloorRef.current.style.border = "1px solid red";
    //   isValid = false;
    // }
    if (!propertyInspector || propertyInspector.length === 0) {
      inspectorRef.current?.controlRef?.style?.setProperty(
        "border",
        "1px solid red"
      );
      isValid = false;
    } else {
      inspectorRef.current?.controlRef?.style?.setProperty(
        "border",
        "1px solid #ccc"
      );
    }

    if (!propertyApprover || propertyApprover.length === 0) {
      approverRef.current?.controlRef?.style?.setProperty(
        "border",
        "1px solid red"
      );
      isValid = false;
    } else {
      approverRef.current?.controlRef?.style?.setProperty(
        "border",
        "1px solid #ccc"
      );
    }
    const cleaned = floorEntries.filter((obj) => {
      const floorValid =
        obj.floor && obj.floor.trim().toLowerCase() !== "select";
      const imageValid = obj.image && obj.image !== null;
      // Keep if at least one of the two is valid
      return floorValid || imageValid;
    });
    console.log(cleaned);
    const isEmptyFloorEntries = checkFloorEntries(cleaned);
    if (!isEmptyFloorEntries) {
      const validatedFloor = validateFloorEntries(cleaned);
      const isEmptyAnyFloor = validatedFloor.some(
        (entry) => entry.requireFloor !== "" || entry.requireImage !== ""
      );
      if (isEmptyAnyFloor) {
        isValid = false;
        setFloorEntries(validatedFloor);
      }
    }
    //final valid flag check
    if (!isValid) {
      isValid = true;
      setValidationFlag(true);
      setLoading(false);
      return;
    }

    const payloadComplianceDocs = await buildPayload(files);
    //console.log("payloadComplianceDocs", payloadComplianceDocs);
    // const complianceDocsPayload = payloadComplianceDocs.map((doc) => ({
    //   complianceType: doc.complianceType,
    //   complianceFileName: doc.complianceFileName,
    //   complianceFile: doc.base64, // you must convert file to base64 before this step
    // }));

    // if (!propertyName.trim()) {
    //   nameRef.current.style.border = "2px solid red";
    // }
    // if (!propertyAddress.trim()) {
    //   addressRef.current.style.border = "2px solid red";
    // }
    // if (!propertyPostalCode.trim()) {
    //   postalCodeRef.current.style.border = "2px solid red";
    // }
    // if (!propertyCity.trim()) {
    //   cityRef.current.style.border = "2px solid red";
    // }

    const formDataToUploadProperty = new FormData();
    formDataToUploadProperty.append("File", propertImage);
    formDataToUploadProperty.append("ClientId", clientObj?.clientId);
    formDataToUploadProperty.append("propertyName", propertyName);
    formDataToUploadProperty.append("propertyAddress", propertyAddress);
    formDataToUploadProperty.append("PostalCode", propertyPostalCode);
    formDataToUploadProperty.append("CityId", propertyCity);

    // formDataToUploadProperty.append(
    //   "TotalNoOfFloors",
    //   totalFloor === undefined ? null : totalFloor
    // ); // TODP: Need to pass
    formDataToUploadProperty.append(
      "TotalNoOfFloors",
      totalFloor === undefined || totalFloor === "" ? "" : String(totalFloor)
    );
    formDataToUploadProperty.append("PropertyStatus", propertyStatus);
    const selectedInspector = propertyInspector?.map((u) => u.value);
    selectedInspector.forEach((value) => {
      formDataToUploadProperty.append("InspectorIds[]", value); // Use '[]' in the key for server-side parsing as an array
    });
    //formDataToUploadProperty.append("InspectorIds", selectedInspector);
    const selectApprover = propertyApprover?.map((u) => u.value);
    selectApprover.forEach((value) => {
      formDataToUploadProperty.append("ApproverIds[]", value); // Use '[]' in the key for server-side parsing as an array
    });
    // formDataToUploadProperty.append("ApproverIds", selectApprover);
    formDataToUploadProperty.append(
      "BlockName",
      propertyBlockObj?.blockName || ""
    );
    formDataToUploadProperty.append("blockId", propertyBlockObj?.blockId || "");
    // complianceType: fe.type, // from dropdown
    //     complianceFileName: fe.docName, // editable name
    //     complianceFile: fe.file,
    // formDataToUploadProperty.append(
    //   "complianceDocs",
    //   JSON.stringify(payloadComplianceDocs)
    // );
    if(files?.length > 0){

  
    files?.forEach((fileObj, index) => {
      formDataToUploadProperty.append(
        `complianceDocs[${index}].complianceType`,
        fileObj.type || 0
      );
      formDataToUploadProperty.append(
        `complianceDocs[${index}].complianceFileName`,
        fileObj.docName
      );
      formDataToUploadProperty.append(
        `complianceDocs[${index}].complianceFile`,
        fileObj.file
      ); //this is file obj
    })  }else{
      formDataToUploadProperty.append(`complianceDocs`, null);
    }
    console.log("formDataToUploadProperty", formDataToUploadProperty, payloadComplianceDocs);

    try {
      const response = await fetch(hostName + ADD_PROPERTY_BY_CLIENT_ID, {
        method: "POST",
        body: formDataToUploadProperty,
        headers: {
          Authorization: "Bearer " + userObj?.token,
          Accept: "application/json",
        },
      });

      const data = await response.json();
      if (response?.status === 401) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: data?.message,
        });
        setTimeout(() => {
          window.location.href = generatePath("/client/:clientNameParam/", {
                                      clientNameParam,
                                    });
        }, 2000);
      }
      if (response.status === 200 && !checkFloorPlanDataIsAvailable()) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Property has been successfully added.",
          });
        }, 2000);
      }
      if (response.status === 200 && checkFloorPlanDataIsAvailable()) {
        const PropertyMasterID = getPropertyId(data.response.message);
        const formDataToUploadFloorPlan = new FormData();

        const floorPlanFiles = await Promise.all(
          floorEntries.map(async (entry) => {
            let base64Image = "";
            if (entry.image) {
              base64Image = entry.image;
            }
            return {
              floorNumber: Number(entry.floor) || 0,
              floorImage: base64Image,
            };
          })
        );
        floorPlanFiles.forEach((fileObj, index) => {
          formDataToUploadFloorPlan.append(
            `floorPlanFiles[${index}].FloorNumber`,
            fileObj.floorNumber
          );
          formDataToUploadFloorPlan.append(
            `floorPlanFiles[${index}].FloorImage`,
            fileObj.floorImage
          ); // This is a File object
        });
        // formDataToUploadFloorPlan.append(
        //   "floorPlanFiles",
        //   JSON.stringify(floorPlanFiles)
        // );
        formDataToUploadFloorPlan.append("ClientId", clientObj.clientId);
        formDataToUploadFloorPlan.append("PropertyMasterID", PropertyMasterID);
        try {
          const responseFloorPlans = await fetch(
            hostName + POST_PROPERTY_FLOOR_IAMGE,
            {
              method: "POST",
              body: formDataToUploadFloorPlan,
              headers: {
                Authorization: "Bearer " + userObj?.token,
              },
            }
          );
          const responseFloorPlansData = await responseFloorPlans.json();
          if (responseFloorPlansData?.status === 401) {
            setToastData({
              toastShow: true,
              toastType: "failure",
              toastString: data?.message,
            });
            setTimeout(() => {
              window.location.href = generatePath("/client/:clientNameParam/", {
                                          clientNameParam,
                                        });
            }, 2000);
          }
          if (responseFloorPlansData?.isError) {
            setToastData({
              toastShow: true,
              toastType: "failure",
              toastString: responseFloorPlansData?.message,
            });
            handleResetAddPropertyForm();
          }
          if (responseFloorPlans?.status === 200) {
            setTimeout(() => {
              setToastData({
                toastShow: true,
                toastType: "success",
                toastString: "Property has been successfully added.",
              });
            }, 2000);
            setLoading(false);
            handleGetAllPropertyByClinetID(clientObj.clientId);
          }
        } catch (error) {
          return error;
        }
        //handleGetAllPropertyByClinetID(clientObj.clientId);
      } else if (response.status === 400) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: data?.message,
        });
      } else {
        throw new Error(`HTTP error! status: ${response}`);
      }
    } catch (error) {
      return error;
    } finally {
      setLoading(false);
      handleResetAddPropertyForm();
      handleGetAllPropertyByClinetID(clientObj.clientId);
      // setSaving(false);
    }
  };

  const handleEditProperty = (id) => {
    const editPropertyDetails = allPropertyList?.filter((data) => {
      return data.propertyMasterId === id;
    });
    setEditProperty(editPropertyDetails);
    setRenderUpdateProperty(true);
  };

  const handleDeleteProperty = async (data) => {
    // const newFormPayload = {
    //   clientId: clientObj.clientId,
    //   propertyMasterId: data?.propertyMasterId,
    // blockName: data.blockName,
    // blockId: data.blockId,
    // isActive: false,
    // propertyName: data.propertyName,
    // propertyLocation: data.propertyAddress || "",
    // postalCode: data.propertyPostalCode || "",
    // propertyImage: data.propertyImage || "",
    // cityId: data.cityId.toString() || "",
    // inspectors: (data.inspectors || []).map((i) => i.userId ?? i),
    // approvers: (data.approvers || []).map((i) => i.userId ?? i),
    // complianceDocs: data.complianceDocs || [],
    // totalNoOfFloors: parseInt(data.totalNoOfFloors, 10) || 0,
    // propertyStatus: data.propertyStatus || "Active",
    // };
    try {
      const response = await http.delete(
        DELETE_PROPERTY_BY_MASTER_ID +
          `?propertyMasterId=${data?.propertyMasterId}&ClientId=${clientObj.clientId}&LoggedinUserEMail=${userObj?.userEmail}`
      );
      if (response.status === 200 && response?.data?.result?.isSuccess) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: response?.data?.result?.message,
          });
        }, 2000);

        // setShowUpdatePropertyModal(false);
        handleGetAllPropertyByClinetID(clientObj.clientId);
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: response?.data?.result?.message,
          });
        }, 2000);
      }
    } catch (error) {
      return error;
    }
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState(null);
  const tableColumns = [
    {
      field: "propertyName",
      height: 50,
      width: 250,
      minWidth: 250,
      headerName: "Property Name",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "propertyLocation",
      height: 50,
      width: 220,
      minWidth: 220,
      headerName: "Property Address",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "totalNoOfFloors",
      width: 50,
      height: 50,
      headerName: "Total Floor",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      type: "string",
      minWidth: 50,
      flex: 1,
      renderCell: (data) => {
        return (
          <>
            {data?.row?.totalNoOfFloors === null
              ? "-"
              : data?.row?.totalNoOfFloors}
          </>
        );
      },
    },
    {
      field: "inspectors",
      headerName: "Inspector(s)",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 220,
      flex: 1,
      renderCell: (data) => {
        return (
          <>{data?.row?.inspectors?.map((item) => item.fullName).join(", ")}</>
        );
      },
    },
    {
      field: "approvers",
      headerName: "Approver(s)",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 220,
      flex: 1,
      renderCell: (data) => {
        return (
          <>{data?.row?.approvers?.map((item) => item.fullName).join(", ")}</>
        );
      },
    },

    {
      field: "propertyStatus",
      headerName: "Property Type",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 220,
      flex: 1,
      renderCell: (data) => (
        <Box>
          <IconButton
            tabIndex={0}
            title="Edit Inspection"
            // onClick={() => openEditScreen(data?.row?.inspectionMasterId)}
            onClick={() => {
              handleEditProperty(data?.row?.propertyMasterId);
            }}
          >
            <EditOutlinedIcon sx={{ color: "#EF3800" }} fontSize="small" />
          </IconButton>

          <IconButton
            tabIndex={0}
            title="Delete Inspection"
            onClick={() => {
              setPropertyToDelete(data?.row);
              setShowDeleteModal(true);
            }}
          >
            <DeleteOutlineIcon sx={{ color: "#EF3800" }} fontSize="small" />
          </IconButton>
        </Box>
      ),
    },

    // {
    //   field: "edit",
    //   height: 50,
    //   headerName: "Edit",
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   sortable: false,
    //   filterable: false,
    //   flex: 1,
    //   minWidth: 70,
    //   type: "string",
    //   renderCell: (data) => {
    //     return (
    //       <>
    //         <i
    //           className="fa-solid fa-pen-to-square fa-lg"
    //           title="Edit"
    //           style={{ cursor: "pointer", justifyItems: "center" }}
    //           onClick={() => {
    //             handleEditProperty(data?.row?.id - 1);
    //             setshowUpdatePropertyModal(true);
    //           }}
    //         ></i>
    //       </>
    //     );
    //   },
    // },
    // {
    //   field: "delete",
    //   width: 70,
    //   height: 50,
    //   headerName: "Delete",
    //   headerClassName: "super-app-theme--header",
    //   editable: false,
    //   sortable: false,
    //   filterable: false,
    //   minWidth: 70,
    //   flex: 1,
    //   type: "string",
    //   renderCell: (data) => {
    //     return (
    //       <>
    //         <i
    //           className="fa fa-trash text-danger"
    //           title="Delete"
    //           style={{ cursor: "pointer", justifyItems: "center" }}
    //           onClick={() => {
    //             setPropertyToDelete(data?.row);
    //             setShowDeleteModal(true);
    //           }}
    //         ></i>
    //       </>
    //     );
    //   },
    // },
  ];
  const handleKeyDown = (e) => {
    if (e.key === "." || e.key === "e" || e.key === "-") {
      e.preventDefault();
    }
  };
  // const handleFloorInputChange = (event) => {
  //   const inputValue = event.target.value;
  //   // Remove any non-digit characters (including decimal points)
  //   const integerValue = inputValue.replace(/[^0-9]/g, "");
  //   if (integerValue > 0) {
  //     setShowFloorImages(true);
  //   } else {
  //     setShowFloorImages(false);
  //   }
  //   setTotalFloor(integerValue);
  // };
  const handleFloorInputChange = (e) => {
    const digits = e.target.value.replace(/\D/g, ""); // keep only 0–9
    const normalized = digits === "" ? "" : String(parseInt(digits, 10)); // "" or int-as-string

    setShowFloorImages(normalized !== "" && Number(normalized) > 0);
    setTotalFloor(normalized); // IMPORTANT: "" when empty
  };
  // const [saving, setSaving] = useState(false);
  // const ImageProxyBaseUrl = hostName + "/api/Inspection/api/image?blobUrl=";

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      {userObj && (
        <div className="dashboard_body_main paddingClassForAddProperty">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}

          {/* <Sidebar
            isCollapsed={hideSidebar}
            onToggle={() => setHideSidebar((v) => !v)}
          /> */}
          {/* {false ? (
            <div className="spinloader"></div>
          ) : ( */}
          <>
            {renderAddProperty ? (
              <div
                className="d-flex dashboard_body flex-column py-1 w-100 "
                style={{
                  position: "relative",
                  minHeight: "100vh",
                }}
              >
                <div className="row m-2 mt-3">
                  <div className="text-start mb-4">
                    <p className="fs-3 fw-bold m-0">Add a new property</p>

                    {/* <i
                      className=" fa-solid fa-plus addBlock text-end"
                      title="Add block"
                      onClick={() => {
                        setShowAddBlockModal(true);
                      }}
                      style={{
                        marginLeft: "1020px",
                        marginTop: "-40px",
                      }}
                    >
                      Add Block
                    </i> */}
                    <div className="text-end ms-auto">
                      <button
                        type="button"
                        className="btn btn-primary-invite"
                        onClick={() => {
                          setShowAddBlockModal(true);
                        }}
                      >
                        <i className=" fa-solid fa-plus addBlock"></i> Add Block
                      </button>
                    </div>
                  </div>
                  <div className="card bulid_card border ">
                    <div className="card-body bulid_card_main text-center d-flex flex-column gap-2 py-4">
                      <p className="fs-5 fw-bold m-0 text-start">
                        Property Information
                      </p>
                      <div className="row">
                        {/* <div className="col-12 col-sm-6 col-lg-4 mb-3">
                      <div className="form-floating mb-3">
                        <select
                          className="form-select"
                          name="doorType"
                          id="floatingSelect"
                          aria-label="Floating label select example"
                          value={
                            propertyBlockObj?.blockName
                              ? propertyBlockObj.blockName
                              : ""
                          }
                          onChange={(e) => {
                            handleSelect(e);
                          }}
                        >
                          <option value="">Select block</option>
                          {blocksList?.map((data) => (
                            <option key={data?.blockId} value={data?.blockName}>
                              {data.blockName}
                            </option>
                          ))}
                        </select>
                        <label htmlFor="name">Block</label>
                      </div>
                      </div> */}
                        <div className="mb-3" style={{ width: "50%" }}>
                          <label
                            htmlFor="name"
                            className="form-label text-start d-block fw-semibold"
                          >
                            Block
                          </label>

                          <select
                            className="form-select"
                            name="doorType"
                            maxLength="50"
                            id="floatingSelect"
                            aria-label="Floating label select example"
                            value={
                              propertyBlockObj?.blockName
                                ? propertyBlockObj.blockName
                                : ""
                            }
                            onChange={(e) => {
                              handleSelect(e);
                              blockRef.current.style.border = "";
                            }}
                            ref={blockRef}
                          >
                            <option value="">Select block</option>
                            {blocksList?.map((data) => (
                              <option
                                key={data?.blockId}
                                value={data?.blockName}
                              >
                                {data.blockName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="mb-3" style={{ width: "50%" }}>
                          <label
                            htmlFor="name"
                            className="form-label text-start d-block fw-semibold"
                          >
                            Name <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter property name"
                            id={`name1`}
                            value={propertyName}
                            onChange={(e) => {
                              setPropertName(e.target.value);
                              nameRef.current.style.border = "";
                            }}
                            required
                            ref={nameRef}
                          />
                        </div>

                        <div className="mb-3" style={{ width: "50%" }}>
                          <label
                            htmlFor="address1"
                            className="form-label text-start d-block fw-semibold"
                          >
                            Address <span style={{ color: "red" }}>*</span>
                          </label>
                          <textarea
                            type="text"
                            className="form-control"
                            placeholder="Enter property address"
                            id="address"
                            value={propertyAddress}
                            onChange={(e) => {
                              setPropertAddress(e.target.value);
                              addressRef.current.style.border = "";
                            }}
                            required
                            ref={addressRef}
                            style={{ height: "20px" }}
                          />
                        </div>

                        <div className="mb-3" style={{ width: "50%" }}>
                          <label
                            htmlFor="contact1"
                            className="form-label text-start d-block fw-semibold"
                          >
                            Postal code <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter postal code"
                            id={`contact1`}
                            required
                            value={propertyPostalCode}
                            onChange={(e) => {
                              let formattedValue = e.target.value
                                .toUpperCase()
                                .replace(/\s+/g, "");
                              if (formattedValue.length > 5) {
                                formattedValue =
                                  formattedValue.slice(0, -3) +
                                  " " +
                                  formattedValue.slice(-3);
                              }
                              setPropertPostalCode(formattedValue);
                              postalCodeRef.current.style.border = "";
                              setErrorPostCode(
                                e.target.value ? "" : errorPostCode
                              );
                            }}
                            ref={postalCodeRef}
                          />

                          {errorPostCode && (
                            <span className="formError">{errorPostCode}</span>
                          )}
                        </div>
                        {/* <div className="col-12 col-sm-6 col-lg-4 mb-3">
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="city"
                          value={propertyCity}
                          required
                          onChange={(e) => {
                            setPropertyCity(e.target.value);
                          }}
                        />
                        <label htmlFor="city">
                          City<span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                    </div> */}
                        <div className="mb-3" style={{ width: "50%" }}>
                          <label
                            htmlFor="contact1"
                            className="form-label text-start d-block fw-semibold"
                          >
                            Total Floor
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="address"
                            placeholder="e.g., 10"
                            value={totalFloor}
                            onKeyDown={handleKeyDown}
                            onChange={(e) => {
                              handleFloorInputChange(e);
                              // totalFloorRef.current.style.border = "";
                            }}
                            required
                            step="1"
                            ref={totalFloorRef}
                          />
                        </div>

                        <div className="mb-3" style={{ width: "50%" }}>
                          <label
                            htmlFor="contact1"
                            className="form-label text-start d-block fw-semibold"
                          >
                            City <span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            className="form-select"
                            id={`floor-select`}
                            value={propertyCity}
                            onChange={handleCityChange}
                            aria-label="Floating label select example"
                            ref={cityRef}
                          >
                            <option selected>Select City</option>
                            {city?.map((data) => (
                              <option key={data.cityId} value={data.cityId}>
                                {data.cityName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="mb-3" style={{ width: "50%" }}>
                          <label
                            htmlFor="contact1"
                            className="form-label text-start d-block fw-semibold"
                          >
                            Select Property Status
                          </label>
                          <select
                            className="form-select"
                            id={`floor-select-`}
                            value={propertyStatus}
                            onChange={(e) => setPropertyStatus(e.target.value)}
                            aria-label="Floating label select example"
                          >
                            <option selected value="Active">
                              Active
                            </option>
                            <option value="Archive">Archive</option>
                          </select>
                        </div>
                        <div className="mb-3" style={{ width: "50%" }}>
                          <label
                            htmlFor="contact1"
                            className="form-label text-start d-block fw-semibold"
                          >
                            Select Inspector(s)
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          {/* <select
                            className="form-select"
                            id={`floor-select-`}
                            value={propertyInspector}
                            onChange={(e) =>
                              setPropertyInspector(e.target.value)
                            }
                            aria-label="Floating label select example"
                            ref={inspectorRef}
                          >
                            <option selected value="">
                              Select
                            </option>
                            {inspectorList?.map((data) => (
                              <option key={data.userId} value={data.userId}>
                                {data.userName}
                              </option>
                            ))}
                          </select>
                          <label htmlFor="floatingSelect">
                            Select Inspector{" "}
                          </label> */}
                          <Select
                            isMulti
                            options={inspectorList}
                            value={propertyInspector}
                            required
                            ref={inspectorRef}
                            onChange={(e) => {
                              setPropertyInspector(e);
                              inspectorRef.current?.controlRef?.style?.setProperty(
                                "border",
                                "1px solid #ccc"
                              );
                            }}
                            placeholder="Select Inspector"
                            isClearable
                            menuPortalTarget={document.body}
                            styles={{
                              container: (base) => ({
                                ...base,
                                width: "100%",
                              }),
                              control: (base) => ({
                                ...base,
                                minHeight: "18px",
                              }),
                              placeholder: (base) => ({
                                ...base,
                                textAlign: "left",
                                marginLeft: "4px",
                                color: "#999",
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </div>
                        <div className="mb-3" style={{ width: "50%" }}>
                          <label
                            htmlFor="contact1"
                            className="form-label text-start d-block fw-semibold"
                          >
                            Select Approver(s)
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          {/* <select
                            className="form-select"
                            id={`floor-select`}
                            value={propertyApprover}
                            onChange={(e) =>
                              setPropertyApprover(e.target.value)
                            }
                            aria-label="Floating label select example"
                            ref={approverRef}
                          >
                            <option selected value="">
                              Select
                            </option>
                            {approverList?.map((data) => (
                              <option key={data.userId} value={data.userId}>
                                {data.userName}
                              </option>
                            ))}
                            <option value="achieve">Achieve</option>
                          </select>
                          <label htmlFor="floatingSelect">
                            Select Approver
                          </label> */}
                          {/* <label className="block mb-2 font-medium">
                            Select Approvers
                          </label>
                          <Select
                            isMulti
                            options={approverList}
                            value={propertyApprover}
                            onChange={setPropertyApprover}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          /> */}
                          <Select
                            isMulti
                            options={approverList}
                            value={propertyApprover}
                            required
                            onChange={(e) => {
                              approverRef.current?.controlRef?.style?.setProperty(
                                "border",
                                ""
                              );
                              setPropertyApprover(e);
                            }}
                            placeholder="Select Approvers"
                            isClearable
                            ref={approverRef}
                            menuPortalTarget={document.body}
                            styles={{
                              container: (base) => ({
                                ...base,
                                width: "100%",
                              }),
                              control: (base) => ({
                                ...base,
                                minHeight: "18px",
                              }),
                              placeholder: (base) => ({
                                ...base,
                                textAlign: "left",
                                marginLeft: "4px",
                                color: "#999",
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                          />
                        </div>
                        <div className="mb-3 " style={{ width: "50%" }}>
                          <label
                            htmlFor="contact1"
                            className="form-label text-start d-block fw-semibold"
                          >
                            Main door Image
                          </label>
                          <div className={`input-group customerFileBtn mb-3`}>
                            <label
                              className="input-group-text"
                              htmlFor="inputGroupFile"
                              style={{
                                height: "36px",
                                fontSize: "15px",
                                lineHeight: 2,
                                color: " #081634",
                                backgroundColor: "white",
                                border: "1px solid #081634",
                                borderRadius: "5px",
                              }}
                            >
                              Choose File
                            </label>
                            <input
                              type="file"
                              className="form-control"
                              id="inputGroupFile"
                              style={{
                                height: "36px",
                                border: "none",
                                color: "#6B7280",
                              }}
                              accept=".jpg, .jpeg, .png, .gif"
                              onChange={handleFileChange}
                              ref={fileInputRef}
                            />
                          </div>
                          {previewPropertImage && (
                            <div className="mt-2">
                              <p className="text-sm text-gray-600 mb-1">
                                Preview:
                              </p>
                              <img
                                height="150px"
                                width="150px"
                                src={previewPropertImage}
                                alt="Main Door"
                                className="w-48 h-48 object-cover rounded-lg border"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {showFloorImages && (
                    <div className="row m-0 p-0 mt-4 mb-3">
                      <div className="card bulid_card border-0">
                        <div className="col-12 col-sm-10 col-lg-8 mb-3 mt-4 ps-3">
                          <h5 className="text-start">Floor Images</h5>
                        </div>
                        {console.log("Floor Entries value ", floorEntries)}
                        {floorEntries?.map((entry, index) => (
                          // eslint-disable-next-line react/jsx-key
                          <div className="row mt-2 ps-3 ">
                            <div className="mb-3" style={{ width: "50%" }}>
                              <select
                                className={
                                  entry.requireFloor
                                    ? "form-select input-error"
                                    : "form-select"
                                }
                                id={`floor-select-${index}`}
                                value={entry.floor}
                                onChange={(e) =>
                                  handleFloorChange(index, e.target.value)
                                }
                                aria-label="Floating label select example"
                              >
                                <option selected>Select Floor</option>
                                {floorOptions.map((floor) => {
                                  const floors = floorEntries?.map(
                                    (floor) => floor.floor
                                  );
                                  const isSelectedElsewhere =
                                    floors.includes(floor.toString()) &&
                                    entry.floor !== floor.toString(); // allow current selection
                                  return (
                                    <option
                                      disabled={isSelectedElsewhere}
                                      key={floor}
                                      value={floor}
                                    >
                                      {floor}
                                    </option>
                                  );
                                })}
                              </select>

                              {entry.requireFloor && (
                                <span className="formError">
                                  {entry.requireFloor}
                                </span>
                              )}
                            </div>

                            <div
                              className="mb-3 d-flex flex-row justify-content-between align-items-start"
                              style={{ width: "50%" }}
                            >
                              <div>
                                <div className="d-flex gap-2">
                                <input
                                  type="file"
                                  className={
                                    entry.requireImage
                                      ? "input-error form-control"
                                      : "form-control"
                                  }
                                  // style={{
                                  //   height: "36px",
                                  //   border: "none",
                                  //   color: "#6B7280",
                                  // }}
                                  // accept=".pdf, .dwg, .jpg, .png, .jpeg"
                                  accept=".jpg, .jpeg, .png, .gif"
                                  id={`image-upload-${index}`}
                                  ref={(el) =>
                                    (floorInputRef.current[index] = el)
                                  }
                                  onChange={(e) =>
                                    handleImageChange(index, e.target.files[0])
                                  }
                                />{entry.floor && entry.floor != "Select Floor" && <span style={{ color: "red" }}>*</span>}</div>
                                {entry.requireImage && (
                                  <span className="formError">
                                    {entry.requireImage}
                                  </span>
                                )}
                              </div>
                              {/* <IconButton
                                tabIndex={0}
                                title="Delete Image"
                                onClick={() => handleRemoveFloor(index)}
                                // style={{ marginRight: "15px"}}
                              >
                                <DeleteOutlineIcon sx={{ color: "#EF3800" }} />
                              </IconButton> */}
                              <div className="px-3">
                                <img
                                  src={delicon}
                                  alt="Delete"
                                  onClick={() => handleRemoveFloor(index)}
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    cursor: "pointer",
                                    marginTop: "10px",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                        <button
                          type="submit"
                          className="btn btn-primary"
                          style={{
                            width: "180px",
                            fontSize: "10px",
                            marginBottom: "20px",
                          }}
                          onClick={handleAddFloor}
                          disabled={floorEntries.length == totalFloor}
                        >
                          <i
                            className=" fa-solid fa-plus addFloorPlanButton"
                            title=" Add Floor image"
                            onClick={() => {
                              // setShowAddBlockModal(true);
                            }}
                          >
                            Add Floor Plan Image
                          </i>
                        </button>
                      </div>
                    </div>
                  )}

                  <div className="row m-0 p-0 mt-4 mb-3">
                    <div className="card bulid_card border-0">
                      <div className="row mt-4 ">
                        {/* <div className="col-12 col-sm-10 col-lg-8 mb-3 ps-3">
                      <h5 className="text-start">Additional Document</h5>
                    </div>
                    <div
                      className=""
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                    >
                      <div className="upload-area" id="upload-area">
                        <p className="mb-2">
                          <strong>Drag & drop files here</strong>
                        </p>
                        <p className="text-muted">or click to browse</p>
                        <input
                          type="file"
                          id="fileInput"
                          multiple
                          hidden
                          onChange={(e) =>
                            handleAddtionalSectionFileChange(e)
                          }
                        />
                        <label htmlFor="fileInput">
                          <button type="button" className="btn btn-primary">
                            Browse Files
                          </button>
                        </label>
                      </div>
                    </div> */}

                        <FileUpload
                          setFiles={setFiles}
                          files={files}
                          setError={setError}
                          error={error}
                          setShowValidation={setShowValidation}
                          showValidation={showValidation}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row" style={{ paddingBottom: "25px" }}>
                  <div>
                    {" "}
                    {validationFlag && (
                      <small style={{ color: "red" }} className=" mb-1">
                        * Please fill all required fields
                      </small>
                    )}
                  </div>
                  <div className="d-flex justify-content-end gap-4 ">
                    <button
                      type="button"
                      className="btn btn-tertiary"
                      style={{ width: "120px" }}
                      onClick={() => {
                        handleResetAddPropertyForm();
                      }}
                    >
                      Reset
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ width: "120px" }}
                      onClick={() => {
                        handleResetAddPropertyForm();
                        setRenderAddProperty(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{ width: "120px", marginRight: "10px" }}
                      onClick={handleSaveProperty}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            ) : renderUpdateProperty ? (
              <UpdateProperty
                setRenderUpdateProperty={setRenderUpdateProperty}
                blocksList={blocksList}
                editPropertyDetails={editProperty[0]}
                clientId={clientObj.clientId}
                handleGetAllPropertyByClinetID={handleGetAllPropertyByClinetID}
                cityList={city}
                inspectorList={inspectorList}
                approverList={approverList}
                setToastData={setToastData}
              />
            ) : (
              <div className="d-flex dashboard_body flex-column py-1 w-100">
                <div className="w-100">
                  <div className="row col-12 mt-3">
                    <div className="text-start ms-3">
                      <p className="fs-3 fw-bold m-0">Properties</p>
                      <p className="fs-6 m-0">
                        Manage and track all properties.
                      </p>
                    </div>
                  </div>

                  <div className="row py-3 align-items-center g-3 px-3 ">
                    {/* Search Bar */}
                    <div className="custom_toolbar_search col-6 col-md-2">
                      <i className="fa-solid fa-magnifying-glass"></i>
                      <input
                        type="text"
                        className="form-control custom_toolbar_control"
                        placeholder="Search properties" // kept your text
                        value={toolbar.searchText}
                        onChange={(e) =>
                          setToolBar({
                            ...toolbar,
                            searchText: e.target.value,
                          })
                        }
                      />
                    </div>

                    {/* Dropdowns */}
                    <div className="col-6 col-md-2">
                      <select
                        className="form-select custom_toolbar_control"
                        value={toolbar.property_name}
                        onChange={(e) =>
                          setToolBar({
                            ...toolbar,
                            property_name: e.target.value,
                          })
                        }
                      >
                        <option value="Propertyname">Property Name</option>
                        {[
                          ...new Set(
                            allPropertyList?.map((user) => user.propertyName)
                          ),
                        ].map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-6 col-md-2">
                      <select
                        className="form-select custom_toolbar_control"
                        value={toolbar.inspector}
                        onChange={(e) =>
                          setToolBar({
                            ...toolbar,
                            inspector: e.target.value,
                          })
                        }
                      >
                        <option value="Inspector">Inspector(s)</option>
                        {uniqueInspectors.map((inspector) => (
                          <option
                            key={inspector.userId}
                            value={inspector.fullName}
                          >
                            {inspector.fullName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-6 col-md-2">
                      <select
                        className="form-select custom_toolbar_control"
                        value={toolbar.approver}
                        onChange={(e) =>
                          setToolBar({ ...toolbar, approver: e.target.value })
                        }
                      >
                        <option value="Approver">Approver(s)</option>
                        {uniqueApprovers.map((approver) => (
                          <option
                            key={approver.userId}
                            value={approver.fullName}
                          >
                            {approver.fullName}
                          </option>
                        ))}
                      </select>
                    </div>

                      <div className="col-6 col-md-1">
                        <select
                          className="form-select custom_toolbar_control"
                          value={toolbar.propertyType}
                          onChange={(e) =>
                            setToolBar({
                              ...toolbar,
                              propertyType: e.target.value,
                            })
                          }
                        >
                          <option value="Property Type">Type</option>
                          {[
                            ...new Set(
                              allPropertyList?.map(
                                (user) => user.propertyStatus
                              )
                            ),
                          ].map((item, index) => (
                            <option key={index} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
{isAnyFilterApplied && (
  <div style={{ width: "auto", paddingLeft: "0px" }}>
    <IconButton
      tabIndex={0}
      title="Clear Filters"
      onClick={() => {
       setToolBar({
          searchText: "",
          property_name: "Propertyname",
          inspector: "Inspector",
          approver: "Approver",
          propertyType: "Property Type",
        })
      }}
    >
      <ClearIcon sx={{ color: "#EF3800" }} fontSize="small" />
    </IconButton>
  </div>
)}
                      {/* Invite Button */}
                      <div className="col-auto ms-auto">
                        <button
                          type="button"
                          className="btn btn-primary-invite"
                          onClick={() => {
                            setRenderAddProperty(true);
                          }}
                        >
                          <i className=" fa-solid fa-plus addBlock"></i> Add
                          Property
                        </button>
                      </div>
                      <div className="col-auto ms-auto">
                        <button
                          type="button"
                          className="btn btn-primary-invite"
                          onClick={() => navigate(
                            generatePath("/client/:clientNameParam/inspection", {
                            clientNameParam,
                          }))}
                        >
                          <i className=" fa-solid fa-plus addBlock"></i> New
                          Inspection
                        </button>
                      </div>

                    {/* Export Button */}
                  </div>
                  <div className="inspection-table" style={{ padding: "20px" }}>
                    <DynamicTable
                      tableData={filteredRows}
                      columnsValue={tableColumns}
                      pageSize={10}
                      pageSizeOptions={[
                        100,
                        150,
                        200,
                        { value: -1, label: "All" },
                      ]}
                    />
                  </div>
                  <div className="inspection-tile">
                    {filteredRows &&
                      filteredRows?.map((item) => {
                        return (
                          // eslint-disable-next-line react/jsx-key
                          <DynamicTiles
                            tableData={item}
                            module="addPropertyDashboard"
                            setPropertyToDelete={setPropertyToDelete}
                            setShowDeleteModal={setShowDeleteModal}
                            handleEditProperty={() => handleEditProperty(item.propertyMasterId)}
                          />
                        );
                      })}
                  </div>
                </div>
              </div>
            )}
            <Footer />
            <div className="bottom-bar-spacing"></div>
            <BottomBarIcons />
            <LoadingComponent loading={loading} />
            {showAddBlockModal && (
              <AddBlockModalPopup
                setShowAddBlockModal={setShowAddBlockModal}
                addNewBlockValue={addNewBlockValue}
                setAddNewBlockValue={setAddNewBlockValue}
                handleAddBlock={handleAddBlock}
                hanleSaveBlock={hanleSaveBlock}
              />
            )}
            {showDeleteModal && (
              <ConfirmationPopup
                show={showDeleteModal}
                headingText="Confirm Delete"
                infoText="Are you sure you want to delete this property? Deleting property will mark all the existing active inspections as canceled."
                cancelText="Cancel"
                submitText="Yes, Delete"
                onCancel={() => {
                  setShowDeleteModal(false);
                  setPropertyToDelete(null);
                }}
                onSubmit={() => {
                  if (propertyToDelete) {
                    handleDeleteProperty(propertyToDelete);
                  }
                  setShowDeleteModal(false);
                }}
              />
            )}
            {/* {editProperty.length > 0 && (
              <UpdateProperty
                setShowUpdatePropertyModal={setshowUpdatePropertyModal}
                blocksList={blocksList}
                editPropertyDetails={editProperty[0]}
                clientId={clientObj.clientId}
                handleGetAllPropertyByClinetID={handleGetAllPropertyByClinetID}
                cityList={city}
                inspectorList={inspectorList}
                approverList={approverList}
                setToastData={setToastData}
              />
            )} */}

            <Toaster
              show={toastData.toastShow}
              toastType={toastData.toastType}
              title={toastData.toastString}
              theme={"dark"}
              position="top-center"
              closeButton={closeButton}
            />
          </>
          {/* // )} */}
        </div>
      )}
    </>
  );
};

export default AddProperty;
